var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4.5H15V3C15 1.3425 13.6575 0 12 0H3C1.3425 0 0 1.3425 0 3V15C0 16.6575 1.3425 18 3 18H16.5C17.325 18 18 17.325 18 16.5V6C18 5.175 17.325 4.5 16.5 4.5ZM3 1.5H12C12.825 1.5 13.5 2.175 13.5 3V4.5H3C2.175 4.5 1.5 3.825 1.5 3C1.5 2.175 2.175 1.5 3 1.5ZM16.5 16.5H3C2.175 16.5 1.5 15.825 1.5 15V5.8725C1.95 6.4275 2.8125 6.75 3.75 6.75H16.5V16.5ZM12 11.25C11.175 11.25 10.5 10.575 10.5 9.75C10.5 8.925 11.175 8.25 12 8.25C12.825 8.25 13.5 8.925 13.5 9.75C13.5 10.575 12.825 11.25 12 11.25Z",
    fill: "#00382F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.576eab66fa80ba81cbbdadc5a9db343a.svg";
export { ForwardRef as ReactComponent };